import { FeedbackList } from "./FeedbackList";

export default function FeedbackDashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Feedback e Suporte</h2>
        <p className="text-muted-foreground">
          Visualize e gerencie feedbacks de usuários e relatórios de erros.
        </p>
      </div>
      <FeedbackList />
    </div>
  );
}
